import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const tabSwitchFn = /* @__PURE__ */ createRecipe('rp-tab-switch', {}, [])

const tabSwitchVariantMap = {
  "size": [
    "medium"
  ],
  "theme": [
    "bet"
  ]
}

const tabSwitchVariantKeys = Object.keys(tabSwitchVariantMap)

export const tabSwitch = /* @__PURE__ */ Object.assign(memo(tabSwitchFn), {
  __recipe__: true,
  __name__: 'tabSwitch',
  raw: (props) => props,
  variantKeys: tabSwitchVariantKeys,
  variantMap: tabSwitchVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, tabSwitchVariantKeys)
  },
})